<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link
        ><span class="pfimg3"
          ><i class="fa fa-angle-right" aria-hidden="true"></i></span
        ><a class="decoration">Employee </a
        ><span class="pfimg3"
          ><i class="fa fa-angle-right" aria-hidden="true"></i></span
        ><router-link class="decoration" to="/timesheet/index">
          Manage Timesheet</router-link
        ><span class="pfimg3"
          ><i class="fa fa-angle-right" aria-hidden="true"></i
        ></span>
        Create Timesheet
      </h6>
      <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
      <div style="padding-bottom: 100px" class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="SaveProduct()">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label class="custom-label" style="font-size: small"
                      >Client</label
                    >
                    <v-select
                      class="font-size_def"
                      label="label"
                      v-model="alldata.customer"
                      :options="mcustomers"
                    ></v-select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small"
                      >Date
                    </label>
                    <input
                      type="Date"
                      v-model="alldata.date"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small"
                      >From</label
                    >
                    <input
                      type="time"
                      v-model="alldata.from"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small"
                      >To
                    </label>
                    <input
                      type="time"
                      v-model="alldata.to"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small"
                      >File Upload</label
                    >
                    <input
                      type="file"
                      @change="handleFileUpload"
                      class="form-control bdr-rad font-size_def"
                    />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small"
                      >Comment
                    </label>
                    <textarea
                      v-model="alldata.comment"
                      class="form-control bdr-rad font-size_def"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div style="border-bottom: 0px; padding-top: 0px" class="navbar">
                <div class="d-flex"></div>
                <div class="d-flex">
                  <button
                    type="submit"
                    class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
                  >
                    Save
                  </button>
                </div>
              </div>
              <br /><br />
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
    <content-footer></content-footer>
  </div>
</template>
    <script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  mounted() {
    this.loadCustomer();
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),

      file: null,
      alldata: {},
      mcustomers: [],

      sections: [
        { label: "Section1", value: "section1" },
        { label: "Section2", value: "section2" },
        { label: "Section3", value: "section3" },
        { label: "Section4", value: "section4" },
      ],
    };
  },
  components: {
    "v-select": vSelect,
    ContentFooter,
    TopNavbar,
  },

  methods: {
    async loadCustomer() {
      try {
        const { data } = await axios.get(
          "/mcustomer/customerload",
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-type": "application/json",
            },
          }
        );
        console.log(data);
        this.mcustomers = data.customers;
      } catch (error) {
        console.log(error.response);
      }
    },

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async SaveProduct() {
      // if (!this.file) {
      //   alert("Please select an Excel file first.");
      //   return;
      // }
      console.log(this.alldata.select);
      const formData = new FormData();
      formData.append("excel_file", this.file);
      formData.append("select_value", JSON.stringify(this.alldata));
      formData.append("userid", JSON.stringify(this.userid));

      try {
        const response = await axios.post(
          "/mproduct/createtimesheet",
          formData,
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-Type": "multipart/form-data",
              //'Content-type': 'application/json',
            },
          }
        );

        const data = response;
        console.log(data.data);
        if (data.data.status == 200) {
          alert("Product data uploaded successfully!");
          // window.location.reload();
        } else {
          console.error("Upload failed:", data.message || data);
          alert("Upload failed. Please check the file format or server logs.");
        }
      } catch (error) {
        console.error("Upload error:", error.response || error);
        alert("An error occurred while uploading the file.");
      }
    },
  },
};
</script>

    <style scoped>
.vs__dropdown-toggle {
  border-radius: 10px !important;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
</style>
